import { Text } from '@hawkins/components';

interface LoadingTextProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const LoadingText = ({ children, style }: LoadingTextProps) => (
  <Text style={{ 
    color: 'white', 
    textAlign: 'center', 
    marginBottom: '20px',
    fontSize: '18px',
    ...style
  }}>
    {children}
  </Text>
);

export default LoadingText;